<template>
  <!-- Modal -->
  <div>
    <div class="modal fade" ref="vuemodal" id="EditAboutModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">{{ translations('header.setting_information_company') }}</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form :class="this.wasValidated ? 'was-validated' : ''">
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.company_name') }}</h6>
                <input
                 :readonly="!isAdmin"
                  type="text"
                  v-model="form.company_name"
                  v-validate="'required'"
                  data-vv-name="company_name"
                  data-vv-as="会社名"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{ translations('infor_company.company_name_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.post_code') }}</h6>
                <input
                 :readonly="!isAdmin"
                  type="text"
                  v-model="form.zipcode"
                  v-validate="'required'"
                  data-vv-name="zipcode"
                  data-vv-as="郵便番号"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{ translations('infor_company.post_code_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.address') }}</h6>
                <input
                 :readonly="!isAdmin"
                  type="text"
                  v-model="form.address"
                  v-validate="'required'"
                  data-vv-name="address"
                  data-vv-as="住所"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{translations('infor_company.address_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.phone_number') }}</h6>
                <input
                 :readonly="!isAdmin"
                  type="text"
                  v-model="form.phone"
                  v-validate="'required'"
                  data-vv-name="phone"
                  data-vv-as="電話番号"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{ translations('infor_company.phone_number_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.fax_number') }}</h6>
                <input
                 :readonly="!isAdmin"
                  type="text"
                  v-model="form.fax"
                  v-validate="'required'"
                  data-vv-name="fax"
                  data-vv-as="FAX番号"
                  class="form-control"
                  required>
                <div class="invalid-feedback">
                  {{ translations('infor_company.fax_number_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.account_manager_name') }}</h6>
                <input
                 :readonly="!isAdmin"
                  type="text"
                  v-model="form.approver1"
                  v-validate="'required'"
                  data-vv-name="approver1"
                  data-vv-as="経理担当者名"
                  class="form-control"
                  required>
                <div class="invalid-feedback">
                  {{ translations('infor_company.account_manager_name_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.account_manager_name_2') }}</h6>
                <input
                 :readonly="!isAdmin"
                  type="text"
                  v-model="form.approver2"
                  v-validate="''"
                  data-vv-name="approver2"
                  data-vv-as="経理担当者名2"
                  class="form-control"
                  >
                <div class="invalid-feedback">
                  {{ translations('infor_company.account_manager_name_2_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.start_date_account_period') }}</h6>
                <div class="form-inline">
                  <select
                   :disabled="!isAdmin"
                    v-model="form.month"
                    v-validate="'required'"
                    data-vv-name="month"
                    data-vv-as="会計期間の開始日"
                    class="custom-select min-width-150 mr-3"
                    required>
                    <option value="" selected="">-</option>
                    <option value="01">{{ translations('infor_company.jan') }}</option>
                    <option value="02">{{ translations('infor_company.feb') }}</option>
                    <option value="03">{{ translations('infor_company.mar') }}</option>
                    <option value="04">{{ translations('infor_company.apr') }}</option>
                    <option value="05">{{ translations('infor_company.may') }}</option>
                    <option value="06">{{ translations('infor_company.jun') }}</option>
                    <option value="07">{{ translations('infor_company.jul') }}</option>
                    <option value="08">{{ translations('infor_company.aug') }}</option>
                    <option value="09">{{ translations('infor_company.sep') }}</option>
                    <option value="10">{{ translations('infor_company.oct') }}</option>
                    <option value="11">{{ translations('infor_company.nov') }}</option>
                    <option value="12">{{ translations('infor_company.dec') }}</option>
                  </select>
                  <select
                   :disabled="!isAdmin"
                    v-model="form.day"
                    v-validate="'required'"
                    data-vv-name="day"
                    data-vv-as="会計期間の開始日"
                    class="custom-select min-width-150 mr-3"
                    required>
                    <option value="" selected="">-</option>
                    <option value="01">{{ translations('infor_company.1st') }}</option>
                    <option value="02">{{ translations('infor_company.2nd') }}</option>
                    <option value="03">{{ translations('infor_company.3rd') }}</option>
                    <option value="04">{{ translations('infor_company.4th') }}</option>
                    <option value="05">{{ translations('infor_company.5th') }}</option>
                    <option value="06">{{ translations('infor_company.6th') }}</option>
                    <option value="07">{{ translations('infor_company.7th') }}</option>
                    <option value="08">{{ translations('infor_company.8th') }}</option>
                    <option value="09">{{ translations('infor_company.9th') }}</option>
                    <option value="10">{{ translations('infor_company.10th') }}</option>
                    <option value="11">{{ translations('infor_company.11th') }}</option>
                    <option value="12">{{ translations('infor_company.12th') }}</option>
                    <option value="13">{{ translations('infor_company.13th') }}</option>
                    <option value="14">{{ translations('infor_company.14th') }}</option>
                    <option value="15">{{ translations('infor_company.15th') }}</option>
                    <option value="16">{{ translations('infor_company.16th') }}</option>
                    <option value="17">{{ translations('infor_company.17th') }}</option>
                    <option value="18">{{ translations('infor_company.18th') }}</option>
                    <option value="19">{{ translations('infor_company.19th') }}</option>
                    <option value="20">{{ translations('infor_company.20th') }}</option>
                    <option value="21">{{ translations('infor_company.21st') }}</option>
                    <option value="22">{{ translations('infor_company.22nd') }}</option>
                    <option value="23">{{ translations('infor_company.23rd') }}</option>
                    <option value="24">{{ translations('infor_company.24th') }}</option>
                    <option value="25">{{ translations('infor_company.25th') }}</option>
                    <option value="26">{{ translations('infor_company.26th') }}</option>
                    <option value="27">{{ translations('infor_company.27th') }}</option>
                    <option value="28">{{ translations('infor_company.28th') }}</option>
                    <option value="29">{{ translations('infor_company.29th') }}</option>
                    <option value="30">{{ translations('infor_company.30th') }}</option>
                    <option value="31">{{ translations('infor_company.31st') }}</option>
                  </select>
                  <div class="invalid-feedback">
                    {{ translations('infor_company.start_date_account_period_required') }}
                  </div>
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('infor_company.establishment_year') }}</h6>
                <input
                 :readonly="!isAdmin"
                  type="text"
                  v-model="form.found"
                  v-validate="'required'"
                  data-vv-name="found"
                  data-vv-as="設立年"
                  class="form-control"
                  required>
                <div class="invalid-feedback">
                  {{ translations('infor_company.establishment_year_required') }}
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div>
              <button ref="closeEditAboutModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>&nbsp;
              <button v-if="isAdmin" type="submit" class="btn btn-primary" v-on:click="validateBeforeUpdate">{{ translations('common.update') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'EditAboutModal',
  props: {
    companyNames: {}
  },
  data () {
    return {
      form: {},
      wasValidated: false,
      isLoading: false
    }
  },
  created: async function () {
    this.isLoading = true

    await this.getInitData()
  },
  mounted () {
  },
  computed: {
    ...mapState(['currentLanguage']),
    isAdmin: function () {
      return this.$store.getters['User/isAdmin']
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async getInitData () {
      let self = this
      try {
        self.isLoading = true

        let result = await this.$http.post(this.$api_url.account_company)
        if (result.data.status === true) {
          this.form = {
            company_name: result.data.details.company_name,
            zipcode: result.data.details.zipcode,
            address: result.data.details.address,
            phone: result.data.details.phone,
            fax: result.data.details.fax,
            approver1: result.data.details.approver1,
            approver2: result.data.details.approver2,
            month: result.data.details.accounting_period.substr(0, 2),
            day: result.data.details.accounting_period.substr(2, 2),
            found: result.data.details.found
          }
        } else {
          self.$toastr.error(result.data.message, 'エラー')
        }
        self.isLoading = false
      } catch (error) {
        self.isLoading = false
        self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('account:company:catch(error): ', error)
      }
    },

    validateBeforeUpdate: function () {
      var self = this
      self.$validator
        .validateAll()
        .then(function (response) {
          if (response === true) {
            self.updateAbout()
          }
          self.wasValidated = true
        })
        .catch(function (e) {
          // Catch errors
        })
    },

    async updateAbout () {
      var self = this
      try {
        self.isLoading = true

        let accountingPeriod = self.form.month + self.form.day
        let params = {
          company_name: self.form.company_name,
          zipcode: self.form.zipcode,
          address: self.form.address,
          phone: self.form.phone,
          fax: self.form.fax,
          approver1: self.form.approver1,
          approver2: self.form.approver2,
          accounting_period: accountingPeriod,
          found: self.form.found
        }

        let result = await this.$http.post(self.$api_url.account_company_update, params)
        if (result.data.status === true) {
          self.$toastr.info('会社情報の設定が完了しました。', '完了')
          self.$props.companyNames.shift() // REMOVE OLD
          self.$props.companyNames.push(self.form.company_name) // SET NEW
          window.$('#EditAboutModal').modal('hide')
        } else {
          self.$toastr.error(result.data.message, 'エラー')
        }
        self.isLoading = false
      } catch (error) {
        self.isLoading = false
        self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('account:company_update:catch(error): ', error)
      }
    }
  }
}
</script>
